module.exports = __webpack_public_path__ + "static/media/service-page-preview.d57eb376.png";